/* ═══════════════════════════════════════════════════════════════════════════
   Águas de Ipanema — "Complete sua rotina"

   Recalcula o conjunto quando o cliente desmarca um item ou troca a variante,
   e adiciona tudo de uma vez pela AJAX do carrinho.

   O que acontece depois do add é o mesmo caminho do resto do site: o helper
   window.aipAposAdicionar (aguasdeipanema-add-to-checkout.js) dispara
   variant:added → cart:updated → cart:refresh { openMiniCart }, então o
   contador atualiza e a gaveta abre sem recarregar a página.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.__aipRotina) return;
  window.__aipRotina = true;

  function moeda(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function itens(secao) {
    return Array.prototype.slice.call(secao.querySelectorAll('[data-aip-item]'));
  }

  function selecionados(secao) {
    return itens(secao).filter(function (item) {
      var check = item.querySelector('[data-aip-check]');
      return check && check.checked && !check.disabled;
    });
  }

  /* Estado corrente de um item: variante escolhida e seus preços.

     Devolve null quando a variante NÃO resolve (id ou preço ausentes). Antes
     havia `parseInt(...) || 0`, e uma variante que não resolvia virava preço
     zero — foi assim que o card do Kit 3 Bases mostrou R$ 0,00 no Incolor.
     Preço nunca é inventado: ou a variante existe, ou o item não entra na
     conta e o botão avisa. */
  function estado(item) {
    var campo = item.querySelector('[data-aip-variante]');
    if (!campo) return null;
    if (item.dataset.aipInvalido === '1') return null;
    var id = parseInt(campo.value, 10);
    var preco = parseInt(campo.dataset.price, 10);
    if (!id || isNaN(preco)) return null;
    var compare = parseInt(campo.dataset.compare, 10);
    if (isNaN(compare)) compare = 0;
    return {
      id: id,
      preco: preco,
      /* compare_at só conta como "de" quando é maior que o preço atual;
         senão a economia sairia inflada ou negativa */
      compare: Math.max(compare, preco)
    };
  }

  /* Item marcado cuja variante não resolve: trava o CTA com motivo real,
     em vez de deixar passar um id inválido para /cart/add.js (422). */
  function pendentes(secao) {
    return selecionados(secao).filter(function (item) { return !estado(item); });
  }

  /* Conjunto completo = todo item habilitado esta marcado. Item esgotado
     entra desabilitado, entao nao segura o rotulo de "levar tudo". */
  function completo(secao) {
    var habilitados = itens(secao).filter(function (item) {
      var c = item.querySelector('[data-aip-check]');
      return c && !c.disabled;
    });
    if (habilitados.length < 2) return false;
    return habilitados.every(function (item) {
      return item.querySelector('[data-aip-check]').checked;
    });
  }

  function recalcular(secao) {
    var lista = selecionados(secao);
    var total = 0;

    var incompletos = 0;
    lista.forEach(function (item) {
      var e = estado(item);
      if (e) total += e.preco; else incompletos++;
    });

    itens(secao).forEach(function (item) {
      var check = item.querySelector('[data-aip-check]');
      item.classList.toggle('is-desmarcado', !!check && !check.checked);
    });

    var por = secao.querySelector('[data-aip-total-por]');
    if (por) por.textContent = moeda(total);

    var aviso = secao.querySelector('[data-aip-erro]');
    if (aviso && !aviso.dataset.aipFalha) {
      if (incompletos > 0) {
        aviso.hidden = false;
        aviso.textContent = incompletos === 1
          ? 'Escolha uma opção disponível no produto marcado para continuar.'
          : 'Escolha uma opção disponível nos produtos marcados para continuar.';
      } else if (!aviso.textContent || aviso.textContent.indexOf('Escolha uma opção') === 0) {
        aviso.hidden = true;
        aviso.textContent = '';
      }
    }

    var cta = secao.querySelector('[data-aip-add]');
    if (cta) {
      /* só desabilita por motivo real: nada marcado, ou item marcado sem
         variante válida. Nunca por falha interna. */
      cta.disabled = lista.length === 0 || incompletos > 0;
      cta.dataset.aipQtd = lista.length;
      var rotulo = completo(secao) ? cta.dataset.txtTudo : cta.dataset.txtParcial;
      if (rotulo && cta.textContent.trim() !== rotulo) cta.textContent = rotulo;
    }
  }

  /* ─── REAL KIT STRUCTURE RULE ──────────────────────────────────────────
     O card pode ter N seletores (o Kit 3 Bases tem três). A variante sai da
     COMBINAÇÃO das opções escolhidas, resolvida contra o catálogo real do
     produto — nunca por índice, posição do swatch ou texto.
     ──────────────────────────────────────────────────────────────────────── */

  function catalogo(item) {
    if (item.__aipVars) return item.__aipVars;
    var tag = item.querySelector('[data-aip-variantes]');
    if (!tag) return null;
    try { item.__aipVars = JSON.parse(tag.textContent); } catch (e) { item.__aipVars = null; }
    return item.__aipVars;
  }

  /* Produto acima de 250 variantes não cabe no Liquid: busca o catálogo
     completo em /products/<handle>.js e normaliza no mesmo formato. */
  function carregarCatalogo(item) {
    if (item.__aipVars) return Promise.resolve(item.__aipVars);
    if (item.__aipCarregando) return item.__aipCarregando;
    var marca = item.querySelector('[data-aip-catalogo-remoto]');
    if (!marca) return Promise.resolve(catalogo(item));

    item.__aipCarregando = fetch('/products/' + marca.dataset.aipCatalogoRemoto + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.variants) return null;
        item.__aipVars = d.variants.map(function (v) {
          return {
            id: v.id, o: v.options, p: v.price, c: v.compare_at_price || 0,
            a: v.available !== false,
            img: v.featured_image ? v.featured_image.src : undefined
          };
        });
        return item.__aipVars;
      })
      .catch(function () { return null; });
    return item.__aipCarregando;
  }

  /* Valor de opção que não aparece em NENHUMA variante daquela posição não é
     escolhível — clicar nele faria o card cair em outra combinação sem avisar.

     Isso acontece de verdade: o "Kit 3 Bases" tem 343 variantes (7x7x7) e a
     vitrine da Shopify publica no máximo 250. O corte cai no meio, então
     "Incolor" simplesmente não existe na primeira Base para a loja — nem aqui
     nem na PDP nativa. Em vez de fingir que dá, o swatch fica desabilitado. */
  function marcarImpossiveis(item) {
    var vars = catalogo(item);
    if (!vars || !vars.length) return;
    /* ordem irrelevante = todo valor é escolhível em toda posição; riscar
       qualquer um seria mentira, porque a variante existe. */
    if (ordemIrrelevante(item)) {
      item.querySelectorAll('[data-aip-swatch]').forEach(function (sw) {
        sw.classList.remove('is-unavailable');
        sw.removeAttribute('aria-disabled');
        sw.setAttribute('tabindex', '0');
        sw.title = sw.dataset.aipVal;
      });
      item.querySelectorAll('select[data-aip-optgroup] option').forEach(function (o) { o.disabled = false; });
      return;
    }
    var sel = combinacao(item);
    item.querySelectorAll('[data-aip-optgroup]').forEach(function (g) {
      var i = parseInt(g.dataset.aipOptgroup, 10);
      /* Um valor é escolhível quando existe variante com ele nesta posição E
         com as OUTRAS opções como estão agora — é assim que a PDP decide, e
         evita o clique que "não pega" por cair numa combinação inexistente.
         Sem nenhuma seleção ainda, vale a existência simples. */
      var existentes = {};
      vars.forEach(function (v) {
        if (v.o[i] == null) return;
        var casa = true;
        for (var k = 0; k < sel.length; k++) {
          if (k === i || sel[k] == null) continue;
          if (v.o[k] !== sel[k]) { casa = false; break; }
        }
        if (casa) existentes[v.o[i]] = true;
      });
      /* nenhuma combinação casa (estado de transição): não trava tudo */
      var algum = false; for (var z in existentes) { algum = true; break; }
      if (!algum) vars.forEach(function (v) { if (v.o[i] != null) existentes[v.o[i]] = true; });

      if (g.tagName === 'SELECT') {
        Array.prototype.forEach.call(g.options, function (o) {
          o.disabled = !existentes[o.value];
        });
        return;
      }
      g.querySelectorAll('[data-aip-swatch]').forEach(function (sw) {
        var ok = !!existentes[sw.dataset.aipVal];
        sw.classList.toggle('is-unavailable', !ok);
        if (ok) {
          sw.setAttribute('tabindex', '0');
          sw.removeAttribute('aria-disabled');
          sw.title = sw.dataset.aipVal;
        } else {
          sw.removeAttribute('tabindex');
          sw.setAttribute('aria-disabled', 'true');
          sw.title = sw.dataset.aipVal + ' — indisponível nesta posição';
        }
      });
    });
  }

  /* Enquanto o catálogo remoto não chegou, o card não pode ir ao carrinho:
     a combinação escolhida ainda não tem como ser resolvida. */
  function prepararRemotos(secao) {
    secao.querySelectorAll('[data-aip-item]').forEach(function (item) {
      if (item.__aipVars) { marcarImpossiveis(item); return; }
      if (!item.querySelector('[data-aip-catalogo-remoto]')) return;
      carregarCatalogo(item).then(function () {
        marcarImpossiveis(item);
        recalcular(secao);
      });
    });
  }

  /* valor escolhido em cada opção, na ordem das opções do produto */
  function combinacao(item) {
    var sel = [];
    item.querySelectorAll('[data-aip-optgroup]').forEach(function (g) {
      var i = parseInt(g.dataset.aipOptgroup, 10);
      if (g.tagName === 'SELECT') { sel[i] = g.value; return; }
      var m = g.querySelector('[data-aip-swatch].is-selected');
      sel[i] = m ? m.dataset.aipVal : null;
    });
    return sel;
  }

  function mesma(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  /* Kit cujas posições são do MESMO produto (3 Base Stick, 3 Stick Make): as
     opções oferecem exatamente os mesmos valores. Aí a ORDEM não tem
     significado comercial — "10/20/60" e "60/10/20" são o mesmo kit, três
     bases nos mesmos tons. */
  function ordemIrrelevante(item) {
    if (item.__aipMultiset != null) return item.__aipMultiset;
    var vars = catalogo(item);
    if (!vars || !vars.length || vars[0].o.length < 2) return (item.__aipMultiset = false);
    var conj = vars[0].o.map(function () { return {}; });
    vars.forEach(function (v) { v.o.forEach(function (val, i) { conj[i][val] = true; }); });
    var ref = Object.keys(conj[0]).sort().join('\u0000');
    for (var i = 1; i < conj.length; i++) {
      if (Object.keys(conj[i]).sort().join('\u0000') !== ref) return (item.__aipMultiset = false);
    }
    return (item.__aipMultiset = true);
  }

  function chaveMultiset(o) { return o.slice().sort().join('\u0000'); }

  /* valor da opção -> foto do tom, lida dos nomes de arquivo já publicados na
     galeria (20.jpg -> "Stick 20", Incolor.jpg -> "Incolor"). Mesma convenção
     que a PDP usa em aguasdeipanema-kit-variante-media.js. */
  function imagemDoTom(item, valor) {
    if (!valor) return null;
    if (!item.__aipTons) {
      var mapa = {};
      var marca = item.querySelector('[data-aip-imagens]');
      var lista = marca ? String(marca.dataset.aipImagens || '').split(/\s+/) : [];
      lista.forEach(function (u) {
        if (!u) return;
        var arq = u.split('/').pop().split('?')[0].replace(/\.[a-z0-9]+$/i, '');
        var base = arq.split('_')[0];
        if (/^\d{2}$/.test(base)) mapa['stick ' + base] = u;
        else if (/^incolor$/i.test(base)) mapa['incolor'] = u;
      });
      item.__aipTons = mapa;
    }
    return item.__aipTons[String(valor).toLowerCase()] || null;
  }

  /* combinação exata; se não existir, a melhor disponível que respeite o valor
     recém-clicado (mesmo comportamento da PDP, sem deixar estado inválido) */
  function resolver(item, sel, optAlterada) {
    var vars = catalogo(item);
    if (!vars) return null;
    for (var i = 0; i < vars.length; i++) if (mesma(vars[i].o, sel)) return vars[i];

    /* Ordem irrelevante: o cliente escolhe os três tons em qualquer ordem e a
       variante é a que tem esse MESMO conjunto. Sem isso, o catálogo canônico
       (só combinações não-decrescentes, para caber no teto de 250) faria metade
       dos swatches parecer indisponível — e nenhuma variante está indisponível
       de verdade. */
    if (ordemIrrelevante(item)) {
      var alvo = chaveMultiset(sel);
      for (var j = 0; j < vars.length; j++) if (chaveMultiset(vars[j].o) === alvo) return vars[j];
    }

    if (optAlterada == null) return null;
    var alvo = sel[optAlterada];
    var cands = vars.filter(function (v) { return v.o[optAlterada] === alvo; });
    return cands.filter(function (v) { return v.a; })[0] || cands[0] || null;
  }

  /* aplica a variante resolvida: marca os seletores, preço, imagem e o campo
     que o carrinho lê. `optAlterada` manda na imagem — é a última interação. */
  function aplicar(item, v, optAlterada) {
    var campo = item.querySelector('[data-aip-variante]');
    if (!campo) return;

    if (!v) {                                   /* configuração inválida */
      item.dataset.aipInvalido = '1';
      campo.value = '';
      delete campo.dataset.price;               /* preço comercial fica na tela */
      recalcular(item.closest('[data-aip-rotina]'));
      return;
    }
    delete item.dataset.aipInvalido;

    campo.value = v.id;
    campo.dataset.price = v.p;
    campo.dataset.compare = v.c || 0;

    /* Os seletores mostram SEMPRE a variante resolvida: o que está marcado é o
       que vai para o carrinho. Em kit de peças iguais isso reordena o trio
       escolhido (10/20/10 aparece como 10/10/20), sem perder nenhum tom — e é
       o mesmo que a PDP faz, para a tela nunca contar uma história diferente
       do estado real. */
    item.querySelectorAll('[data-aip-optgroup]').forEach(function (g) {
      var i = parseInt(g.dataset.aipOptgroup, 10);
      var val = v.o[i];
      if (g.tagName === 'SELECT') { g.value = val; }
      else {
        g.querySelectorAll('[data-aip-swatch]').forEach(function (sw) {
          sw.classList.toggle('is-selected', sw.dataset.aipVal === val);
        });
      }
      var rot = item.querySelector('[data-aip-swatch-label="' + i + '"]');
      if (rot) rot.textContent = val;
    });

    /* imagem: a da variante resolvida; sem mídia própria, a de uma variante
       que carregue o mesmo valor; e por último o mapa de tons da galeria —
       kit de peças iguais não tem foto do trio, só foto de cada tom. Manda
       sempre o ÚLTIMO valor clicado, não a posição, porque em kit de peças
       iguais a posição muda de lugar na reordenação. */
    var img = item.querySelector('[data-aip-img]');
    if (img) {
      var src = v.img;
      if (!src && optAlterada != null) {
        var vars = catalogo(item) || [];
        var comImg = vars.filter(function (x) { return x.img && x.o[optAlterada] === v.o[optAlterada]; })[0];
        if (comImg) src = comImg.img;
      }
      if (!src) src = imagemDoTom(item, item.__aipUltimoValor || (optAlterada != null ? v.o[optAlterada] : null));
      if (src) { img.src = src; img.removeAttribute('srcset'); }
    }

    pintarPrecoItem(item, v.p, v.c || 0);
    marcarImpossiveis(item);          /* o que é escolhível muda a cada escolha */
    recalcular(item.closest('[data-aip-rotina]'));
  }

  function escolher(item, opt, valor) {
    if (isNaN(opt)) return;
    /* marca a escolha na hora, para o clique não parecer ignorado */
    var g = item.querySelector('[data-aip-optgroup="' + opt + '"]');
    if (g && g.tagName !== 'SELECT') {
      g.querySelectorAll('[data-aip-swatch]').forEach(function (sw) {
        sw.classList.toggle('is-selected', sw.dataset.aipVal === valor);
      });
    }
    var rot = item.querySelector('[data-aip-swatch-label="' + opt + '"]');
    if (rot) rot.textContent = valor;

    item.__aipUltimoValor = valor;      /* a foto segue a última interação */
    carregarCatalogo(item).then(function () {
      var sel = combinacao(item);
      sel[opt] = valor;
      aplicar(item, resolver(item, sel, opt), opt);
    });
  }

  function escolherSwatch(swatch) {
    var item = swatch.closest('[data-aip-item]');
    if (!item) return;
    if (swatch.getAttribute('aria-disabled') === 'true') return;
    escolher(item, parseInt(swatch.dataset.aipOpt, 10), swatch.dataset.aipVal);
  }

  function escolherSelect(select) {
    var item = select.closest('[data-aip-item]');
    if (!item) return;
    escolher(item, parseInt(select.dataset.aipOpt, 10), select.value);
  }

  function pintarPrecoItem(item, preco, compare) {
    var por = item.querySelector('[data-aip-por]');
    var de = item.querySelector('[data-aip-de]');
    var p = parseInt(preco, 10) || 0;
    var c = parseInt(compare, 10) || 0;
    if (por) por.textContent = moeda(p);
    if (de) {
      de.hidden = !(c > p);
      de.textContent = c > p ? moeda(c) : '';
    }
  }

  function adicionar(secao) {
    var cta = secao.querySelector('[data-aip-add]');
    var erro = secao.querySelector('[data-aip-erro]');
    var lista = selecionados(secao);
    if (!lista.length) return;

    if (erro) { erro.hidden = true; erro.textContent = ''; }
    cta.setAttribute('disabled', 'disabled');
    cta.setAttribute('aria-busy', 'true');
    /* clique repetido nao vira dois /cart/add: o CTA fica travado e avisando
       ate a resposta chegar */
    if (cta.dataset.aipRotulo == null) cta.dataset.aipRotulo = cta.textContent;
    cta.textContent = 'ADICIONANDO...';

    /* Uma unidade de cada item marcado. */
    var validos = lista.map(estado).filter(Boolean);
    if (validos.length !== lista.length) {
      if (erro) { erro.hidden = false; erro.dataset.aipFalha = '1';
        erro.textContent = 'Escolha uma opção disponível nos produtos marcados.'; }
      cta.removeAttribute('disabled'); cta.removeAttribute('aria-busy');
      delete erro.dataset.aipFalha;
      return;
    }

    var corpo = {
      items: validos.map(function (e) { return { id: e.id, quantity: 1 }; }),
      sections: ['mini-cart']
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) {
        return r.json().then(function (dados) {
          if (!r.ok) throw new Error(dados.description || dados.message || 'Não foi possível adicionar.');
          return dados;
        });
      })
      .then(function (dados) {
        if (window.aipAposAdicionar) return window.aipAposAdicionar(dados, cta);
      })
      .catch(function (e) {
        /* "Failed to fetch" e "NetworkError" sao texto de navegador, nao
           recado para quem esta comprando. Quando a mensagem vem da API do
           carrinho ela e util e fica; queda de rede vira aviso em portugues
           e o CTA continua clicavel para tentar de novo. */
        var m = String((e && e.message) || '');
        var rede = !m || /failed to fetch|networkerror|load failed|network request failed/i.test(m);
        if (erro) {
          erro.hidden = false;
          erro.textContent = rede
            ? 'Não foi possível falar com a loja agora. Confira sua conexão e toque de novo.'
            : m;
        }
      })
      .finally(function () {
        cta.removeAttribute('disabled');
        cta.removeAttribute('aria-busy');
        if (cta.dataset.aipRotulo != null) {
          cta.textContent = cta.dataset.aipRotulo;
          delete cta.dataset.aipRotulo;
        }
        recalcular(secao);
      });
  }

  document.addEventListener('change', function (e) {
    var secao = e.target.closest && e.target.closest('[data-aip-rotina]');
    if (!secao) return;
    if (e.target.matches('[data-aip-check]')) recalcular(secao);
    if (e.target.matches('select[data-aip-optgroup]')) escolherSelect(e.target);
  });

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('[data-aip-swatch]');
    /* clique no rótulo do tom (abaixo da amostra) vale como clique nela */
    if (!swatch) {
      var tom = e.target.closest && e.target.closest('[data-aip-rotina] .aip-tom');
      if (tom) swatch = tom.querySelector('[data-aip-swatch]');
    }
    if (swatch) { escolherSwatch(swatch); return; }

    var add = e.target.closest && e.target.closest('[data-aip-add]');
    if (add) { adicionar(add.closest('[data-aip-rotina]')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var swatch = e.target.closest && e.target.closest('[data-aip-swatch]');
    if (!swatch) return;
    e.preventDefault();
    escolherSwatch(swatch);
  });

  /* O WhatsApp e a barra sticky sao `fixed` e nao sabem o que ha embaixo
     deles. No mobile o CTA da rotina ocupa a largura inteira e a bolha do
     WhatsApp cai bem em cima do canto direito dele (item 48).

     A raiz do observador E a faixa de baixo da tela: o rootMargin negativo no
     topo encolhe a area observada para os ultimos 180px. Assim o callback
     dispara exatamente quando o CTA entra e sai dessa faixa — sem listener de
     scroll, que em aba de fundo nem roda. Observar a tela inteira nao servia:
     o IntersectionObserver so avisa quando cruza um limiar, entao rolar com o
     CTA ja visivel nunca reavaliava. */
  var FAIXA = 180;

  function vigiarCta() {
    var cta = document.querySelector('[data-aip-rotina] [data-aip-add]');
    if (!cta || !('IntersectionObserver' in window)) return;
    if (cta.__aipObs) cta.__aipObs.disconnect();

    cta.__aipObs = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        document.body.classList.toggle('aip-rotina-cta-embaixo', e.isIntersecting);
        if (e.isIntersecting) {
          var h = Math.round(e.target.getBoundingClientRect().height) || 60;
          document.body.style.setProperty('--aip-rotina-cta-h', h + 'px');
        }
      });
    }, { rootMargin: '-' + Math.max(0, window.innerHeight - FAIXA) + 'px 0px 0px 0px' });

    cta.__aipObs.observe(cta);
  }

  var remedir;
  window.addEventListener('resize', function () {
    clearTimeout(remedir);
    remedir = setTimeout(vigiarCta, 200);      /* a faixa depende da altura da tela */
  });

  function iniciar() {
    vigiarCta();
    document.querySelectorAll('[data-aip-rotina]').forEach(function (secao) {
      recalcular(secao);
      prepararRemotos(secao);
    });
  }

  /* O fallback pode tirar um card depois do primeiro cálculo (item que já está
     no carrinho) ou acrescentar outro. Sem recalcular, o total continua o da
     lista antiga — foi assim que a soma apareceu maior que os cards visíveis.
     Exposto para quem mexe na lista pedir o recálculo explicitamente. */
  window.aipRotinaRecalcular = function (secao) {
    if (secao) recalcular(secao);
    else document.querySelectorAll('[data-aip-rotina]').forEach(recalcular);
  };

  /* rede de segurança: qualquer mudança na lista de itens recalcula */
  document.querySelectorAll('[data-aip-rotina] .aip-rotina__itens').forEach(function (caixa) {
    try {
      new MutationObserver(function () {
        recalcular(caixa.closest('[data-aip-rotina]'));
      }).observe(caixa, { childList: true });
    } catch (e) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else { iniciar(); }

  document.addEventListener('shopify:section:load', iniciar);
})();
